/**
 * @generated SignedSource<<7d18c646b57da2327ca78008b67f644c>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type AgentsCount_organization$fragmentType = any;
export type AgentsCountRefetchQuery$variables = {|
  organizationID: string,
|};
export type AgentsCountRefetchQuery$data = {|
  +organization: ?{|
    +$fragmentSpreads: AgentsCount_organization$fragmentType,
  |},
|};
export type AgentsCountRefetchQuery = {|
  response: AgentsCountRefetchQuery$data,
  variables: AgentsCountRefetchQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationID"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentsCountRefetchQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AgentsCount_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentsCountRefetchQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentConnection",
                "kind": "LinkedField",
                "name": "agents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72982c89565c87c178b20550c196cee8",
    "id": null,
    "metadata": {},
    "name": "AgentsCountRefetchQuery",
    "operationKind": "query",
    "text": "query AgentsCountRefetchQuery(\n  $organizationID: ID!\n) {\n  organization: node(id: $organizationID) {\n    __typename\n    ...AgentsCount_organization\n    id\n  }\n}\n\nfragment AgentsCount_organization on Organization {\n  id\n  uuid\n  agents {\n    count\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "77852487a2a8fa5e439cc942cbb8c437";

module.exports = ((node/*: any*/)/*: Query<
  AgentsCountRefetchQuery$variables,
  AgentsCountRefetchQuery$data,
>*/);
